import { Button, ButtonTheme } from '@cian/button-component';
import { HeartIcon, HeartFilledIcon } from '@cian/ui-kit/prev';
import * as React from 'react';

import { FavoritesButtonContext } from '../../../context';
import * as styles from './DefaultFavoriteButton.css';

export interface IDefaultFavoriteButtonProps {
  checked: boolean;
  onButtonClick(): void;
}

export const DefaultFavoriteButton = ({ checked, onButtonClick }: IDefaultFavoriteButtonProps) => {
  const { customClass } = React.useContext(FavoritesButtonContext);
  const Icon = checked ? HeartFilledIcon : HeartIcon;

  return (
    <Button onClick={onButtonClick} className={customClass ? customClass : styles['button']} theme={ButtonTheme.Ghost}>
      <div className={styles['content']}>
        <Icon custom={{ size: '14' }} styles={{ color: 'E84260' }} />
        <span className={styles['text']}>{checked ? 'В избранном' : 'В избранное'}</span>
      </div>
    </Button>
  );
};
